import appEnv from 'bundles/coursera-plus-landing-page/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
